import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-10 px-4" data-id="element-59">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-4 border-4 border-dashed border-gray-300 p-6 md:p-8 rounded-xl text-center" data-id="element-60">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center border-4 border-yellow-400" data-id="element-61">
          <ShieldCheck className="w-10 h-10 text-yellow-600" data-id="element-62" />
        </div>

        <div data-id="element-63">
          <h2 className="text-2xl font-black text-gray-900 mb-2 font-['Oswald'] uppercase" data-id="element-64">
            Garantía sin riesgo
          </h2>
          <p className="text-base text-gray-700 mb-2" data-id="element-65">
            Probalo durante 7 días. Si no te facilita la planificación y no
            mejora la comprensión en tu aula,
          </p>
          <p className="text-xl font-bold text-gray-900" data-id="element-66">
            Te devolvemos el 100% del dinero.
          </p>
        </div>
      </div>
    </section>;
}